module.exports = __webpack_public_path__ + "img/zone-maximillaire.8f2070d8.png";